import { render, staticRenderFns } from "./Produtos.vue?vue&type=template&id=eac7a86c&scoped=true"
import script from "./Produtos.vue?vue&type=script&lang=js"
export * from "./Produtos.vue?vue&type=script&lang=js"
import style0 from "./Produtos.vue?vue&type=style&index=0&id=eac7a86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac7a86c",
  null
  
)

export default component.exports